// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimer_wrapper__eeeC8 {
  padding: 4px 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
}

.disclaimer_start__GRgHV {
  background-color: var(--start-background-color);
}

.disclaimer_soccer__Z\\+nuc {
  background-color: var(--tertiary-background-color);
}

.disclaimer_player__29vkk {
  background-color: var(--start-background-color);
}

.disclaimer_captain__Hzse\\+ {
  background-color: var(--green-background-color);
}

.disclaimer_start-icon__scSmr {
  fill: var(--start-background-color);
  color: var(--primary-text-color);
}

.disclaimer_soccer-icon__kV9Ra {
  color: var(--primary-text-color);
}

.disclaimer_player-icon__xJXlr {
  color: var(--primary-text-color);
}

.disclaimer_captain-icon__8wLu3 {
  color: var(--primary-text-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/functional/disclaimer.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".wrapper {\n  padding: 4px 6px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: fit-content;\n}\n\n.start {\n  background-color: var(--start-background-color);\n}\n\n.soccer {\n  background-color: var(--tertiary-background-color);\n}\n\n.player {\n  background-color: var(--start-background-color);\n}\n\n.captain {\n  background-color: var(--green-background-color);\n}\n\n.start-icon {\n  fill: var(--start-background-color);\n  color: var(--primary-text-color);\n}\n\n.soccer-icon {\n  color: var(--primary-text-color);\n}\n\n.player-icon {\n  color: var(--primary-text-color);\n}\n\n.captain-icon {\n  color: var(--primary-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `disclaimer_wrapper__eeeC8`,
	"start": `disclaimer_start__GRgHV`,
	"soccer": `disclaimer_soccer__Z+nuc`,
	"player": `disclaimer_player__29vkk`,
	"captain": `disclaimer_captain__Hzse+`,
	"start-icon": `disclaimer_start-icon__scSmr`,
	"soccer-icon": `disclaimer_soccer-icon__kV9Ra`,
	"player-icon": `disclaimer_player-icon__xJXlr`,
	"captain-icon": `disclaimer_captain-icon__8wLu3`
};
export default ___CSS_LOADER_EXPORT___;
